<template>
    <div>
        <header-vue></header-vue>
        <div style="height: 40px"></div>
        <div class="banner">
            <div class="container content">
		<h1 class="u-heading-v2__title g-mb-10">利用規約</h1>

		<h2 class="test-uppercase u-heading-v2__title g-mb-10">本サービスについて</h2>
		<p>本サービスとは、買取TOP ONE ウェブサイト( http://kaitoritopone.jp ) 、または株式会社ＢＩＣ・マックスおよびグループ会社（以下「当社」といいます）が提供する各種サービスをいいます。</p>
		<p>本サービスのご利用にあたり当社ご利用規約（以下「本利用規約」といいます）をよくお読みいただき、ご理解・ご承諾の上ご利用ください。なお、本サービスをご利用いただきました時点で、本利用規約に同意したものとみなします。</p>
		<p>本利用規約とは別に個別規約が定められる場合がございます。この場合、本利用規約とともに個別規約についても同意いただくものといたします。なお、本利用規約と個別規約の定めが異なる場合は、個別規約の定めを優先するものといたします。</p>

		<h2 class="test-uppercase u-heading-v2__title g-mb-10">規約の変更</h2>
		<p>当社は任意に本サービスの内容を定めることができるとし、当社が必要と判断した場合、ご利用者に通知・承諾を得ることなく、内容の一部または全部の変更、追加および廃止をすることができるものとします。</p>

		<h2 class="test-uppercase u-heading-v2__title g-mb-10">本サービスの内容</h2>
		<p>本サービスとは、当社で取り扱う商品等の買取・販売および各種サービスをいいます。ご利用者は、本利用規約に同意いただき、従うものとします。</p>
		<p>買取は店頭への持ち込みによる査定、もしくは商品の郵送で査定を行う買取となります。買取金額は買取一丁目ウェブサイトを参考価格として決定いたします（買取価格は相場変動により変わるため、ウェブサイト掲載の買取価格は参考価格となります）。</p>
		<p>郵送査定の場合は、買取金額を電話で予約することができます（電話予約の翌日午前中までに商品が到着した場合に限ります）。ただし、買取一丁目ウェブサイトに掲載のない商品、電話予約なく郵送いただいた場合はこの限りではありません。</p>
		<p>不正転売目的、強制解約、契約中、盗難品、偽造等による不正契約、割賦金販売の契約で残金が残っている商品については査定および買取できかねますので、あらかじめご了承ください。</p>

		<h2 class="test-uppercase u-heading-v2__title g-mb-10">取引当事者の確認</h2>
		<p>本サービスは古物営業法および青少年健全育成条例に則り運営されます。18歳未満の方は保護者直筆による当社規定の保護者同意書をもってご利用いただけるものとします。</p>
		<p>また古物営業法により、古物の受取・引渡しの時はご本人確認が義務付けられています。買取の際は、以下のご本人確認書類をご用意いただきます。</p>

		<h3 class="u-label g-bg-brown u-label--lg g-font-size-20 g-px-15 g-py-8 g-mr-10 g-mb-15">店頭買取</h3>
		<ul>
			<li>運転免許証</li>
			<li>旅券（パスポート）</li>
			<li>外国人登録証</li>
			<li>住民票の写し（原本） ※発行より3ヶ月以内のものに限ります</li>
			<li>マイナンバーカード（写真面のみ、通知カード不可、店頭に本人持参時のみ）</li>
		</ul>
		<p>※買取成立の際にコピーをいたします</p>


		<h3 class="u-label g-bg-brown u-label--lg g-font-size-20 g-px-15 g-py-8 g-mr-10 g-mb-15">郵送買取（口座振込ご利用の場合）</h3>
		<ul>
			<li>住民票の写し（原本） ※マイナンバーの記載のないもの</li>
			<li>戸籍謄本（原本） ※現住所が入ったもの</li>
			<li>印鑑証明書（原本）</li>
			<li>運転免許証のコピー（表裏） ※当社ご利用、2回目以降のお客様に限ります
		</li></ul>

		<h3 class="u-label g-bg-brown u-label--lg g-font-size-20 g-px-15 g-py-8 g-mr-10 g-mb-15">郵送買取（現金書留ご利用の場合）</h3>
		<ul>
			<li>運転免許証のコピー（表裏）</li>
			<li>旅券（パスポート）のコピー（写真面、住所記載面）</li>
			<li>健康保険証のコピー（表裏、住所を記載したもの）</li>
			<li>官公庁及び特殊法人の身分証明書のコピー（写真付きのもの）</li>
			<li>在留カードのコピー（表裏）</li>
		</ul>

		<h3 class="u-label g-bg-brown u-label--lg g-font-size-20 g-px-15 g-py-8 g-mr-10 g-mb-15">法人の場合（下記のいずれも必要です）</h3>
		<ul>
			<li>登記事項証明書または印鑑登録証明書の原本（発行より3ヶ月以内のものに限ります）</li>
			<li>（ご担当者様、店頭買取の場合はご来店者様の）ご本人確認書類とお名刺</li>
		</ul>

		<p>買取成立後はご提示・ご送付いただきましたご本人確認書類は、古物営業法に基づき買取申込書と一緒に保管し、返却いたしません（買取が成立しなかった場合、ご本人確認書類は返却いたします）。</p>
		<p>ご送付いただいたご本人確認書類が不鮮明だった場合は、再度、本人確認書類を請求いたします。書類到着まで査定いたしかねますのでご了承ください。</p>
		<p>お申込とご本人確認書類が異なる場合や、その他確認事項などがございました時は、メール・お電話にてご連絡の上、別の本人確認書類をご送付いただく場合がございます。<br>
			その際は、ご本人確認書類が当社に到着するまで、査定はお受けいたしかねます。その場合の買取価格は書類が到着した時の査定価格となり、お申込いただいた際の買取価格の保証はいたしかねますので、あらかじめご了承ください。</p>

		<h2 class="test-uppercase u-heading-v2__title g-mb-10">支払方法</h2>
		<p>買取の査定にご同意いただきましたら、ご来店の場合はその場での買取金額のお渡し、郵送の場合は、査定完了後3日以内（土日祝日を除く）に、買取金額をご指定の口座へお振込、もしくは現金書留にて送付いたします。なお、現金書留で買取金額が50万円を超える場合の送金手数料はお客様ご負担となります。</p>
		<p>以下の場合はご対応いたしかねますので、ご了承ください。</p>
		<ul>
			<li>ご本人確認書類と振込先名義人が異なる場合</li>
			<li>ご本人確認書類と現金書留の送付先住所、お名前が異なる場合</li>
			<li>銀行振込、現金書留以外での支払方法</li>
		</ul>

		<h2 class="test-uppercase u-heading-v2__title g-mb-10">キャンセル</h2>
		<p>買取金額にご納得いただけなかった場合は、商品を返送いたします。商品返送は送料着払いで返送いたします。<br>また、いかなる場合でも買取成立後のキャンセルやご返品はお受け致しかねます（本利用規約の違反と判断された場合はこの限りではありません）。</p>

		<h2 class="test-uppercase u-heading-v2__title g-mb-10">申込の承諾</h2>
		<p>当社は、次の場合、本サービスの申込を承諾しない場合があります。また本サービス成立後であっても、次の各号に該当することが判明した場合には、何らかの通知または催告を要することなく、直ちに本サービスの提供を停止することができるものとします。<br>また、当社が本サービスの提供停止の措置を行ったことによってご利用者または第三者に生じた損害について、当社は一切の責任を負わないものとします。</p>
		<ol>
			<li>本利用規約や、その他、当社が定める個別規定に違反した場合</li>
			<li>登録内容および申込内容に虚偽があったことが判明した場合</li>
			<li>不正取得した商品で本サービスを利用する行為</li>
			<li>過去に本サービスの提供停止または登録情報の抹消の措置を受けていたことが判明した場合</li>
			<li>ご利用者が18歳未満で本サービスの申込にあたり保護者の同意を得ていない場合</li>
			<li>ご利用者が、当社また本サービスの信用を損失する恐れのある態様で本サービスを利用する恐れがある場合</li>
			<li>電子メール、電話、その他の連絡手段をもってしても連絡が取れなくなった場合</li>
			<li>赤ロムなど当社への損害に関する料金などの支払債務の履行遅延、その他の不履行があった場合</li>
			<li>当社が不適切と判断した場合</li>
		</ol>

		<h2 class="test-uppercase u-heading-v2__title g-mb-10">会員</h2>
		<p>本利用規約における会員とは、本利用規約に同意の上、ご利用者が所定の手続に従ってIDおよびパスワードの登録を申請し、当社が承認の上で登録したご利用者個人をいいます。</p>

		<h2 class="test-uppercase u-heading-v2__title g-mb-10">会員ID、パスワードの管理</h2>
		<p>IDおよびパスワードの管理は、会員自身で管理責任を負うものといたします。ID、パスワードは第三者に貸与、譲渡、名義変更、売買、質入等してはならないものとし、第三者へ開示しないものといたします。管理不十分、ご使用上の過誤、第三者のご使用等による損害は自身で負うものとし、当社は一切の責任を負わないものとします。<br>もし、IDとパスワードが盗難等にあった場合、または第三者によって不正に使用されていることが判明した場合には、直ちに当社に連絡いただき、当社から指示がありました場合は、これに従うものとします。なお、当社への連絡は会員を免責するものではありません。</p>

		<h2 class="test-uppercase u-heading-v2__title g-mb-10">禁止事項</h2>
		<p>本サービスのご利用にあたって、次の各号に定める行為は行ってはならないものとします。</p>
		<ul>
			<li>本利用規約に反する行為</li>
			<li>本サービスに関連して、第三者の著作権、商標権、その他一切の権利を侵害する行為、またはその恐れのある行為</li>
			<li>虚偽の申込・登録内容を申請する行為</li>
			<li>不正目的にID・パスワードを使用する行為</li>
			<li>犯罪行為、公序良俗に違反する行為、その他法令に違反する行為</li>
			<li>当社および当店の運営を妨げる行為、またはその恐れがある行為</li>
			<li>当社または第三者の著作権、財産権、プライバシー、その他の権利を侵害する行為、またはその恐れがある行為</li>
			<li>コンピューターウィルス等、有害なプログラムを当店に関連して使用・提供・配布する行為</li>
			<li>買取できない商品を送付する行為</li>
			<li>当社が合理的理由に基づき、不適切・不相応と判断する行為</li>
		</ul>

		<h2 class="test-uppercase u-heading-v2__title g-mb-10">免責事項等</h2>
		<ol>
			<li>登録内容・申込内容に虚偽があったことが判明した場合、ご利用者が被った損害又は損失に対して、当社はいかなる保証も行いません。</li>
			<li>本サービスの利用によって、その他のご利用者又は第三者に対し損害を与えた場合、当該利用者は自己の責任と費用により当該損害を賠償する責を負うものとします。</li>
			<li>ご利用者は、本サービスのご利用において行う個人情報のインターネットを介した送信行為等が、情報の漏洩等の危険性を有していることを認識して自己の責任の下にこれを行うものとし、当社は一切の責任を負わないものとします。</li>
			<li>ご利用者が本サービスを通じて得る情報等についていかなる保証も行わず、ご利用者が当該情報を利用して損害を被った場合であっても、当社はその被った損害について賠償するいかなる責任も負わないものとします。</li>
			<li>本サービスの利用により発生したご利用者の損害（他者との間で生じたトラブルに起因する損害を含みます）、および本サービスを利用できなかったことにより発生したご利用者の損害に対し、損害賠償責任その他いかなる責任も負わないものとします。</li>
			<li>返却となった商品の状態、システム環境やデータの保障等については、当社は一切の責を負わないものとします。これにより、査定前の状態への復元は一切いたしません。ご利用者にて復元できなかったことにより損害が発生した場合も、当社はその賠償の責を負わないものとします。</li>
			<li>査定価格は、市場状況、時期、当社在庫、商品の状態等によって変動します。当社がウェブサイトやSNS（当社オフィシャルアカウントに限る）などを通じて表示している参考買取価格は、ご利用者が申込みをした商品の買取価格を保証するものではありません。</li>
			<li>当社の買取価格につきましては、本サービス内のみのご紹介となります。</li>
			<li>本サービスのシステム運営に伴い、ネットワークやシステム不具合、遅延、停止又はデータの消失がないことを一切保証しないものとします。</li>
			<li>輸送中に発生した商品の故障・破損・紛失等について、当社は一切の責任を負わないものとします。</li>
		</ol>
		<p>ただし、当社の故意又は重過失による場合は、その限りではありません。</p>

		<h2 class="test-uppercase u-heading-v2__title g-mb-10">著作権</h2>
		<ol>
			<li>ご利用者は、権利者の承諾を得ずいかなる方法においても、本サービスを通じて提供される著作物等を著作権法で定めるご利用者個人の私的使用の範囲外の目的で使用することはできません。</li>
			<li>別段の定めがない限り、本サービス上での各コンテンツに関する著作権、その他知的財産権は、当社あるいは各コンテンツの提供者に帰属するものとし、また、各コンテンツの集合体としての本サービスの著作権その他知的財産権は、当社に帰属するものと致します。</li>
			<li>本サービスに含まれる全てのコンテンツ及びコンテンツの編集物は、当社または各コンテンツ提供者に権利が帰属する独占的な財産であり、日本の著作権法及び著作権に関する国際法によって保護されています。</li>
			<li>お客様は、本サービスを利用する事により得られる一切の情報を、当社または当該情報の権利者の事前承諾なしにお客様個人の私的使用以外の目的で複製、出版、放送等、方法の如何を問わず第三者に供さないものとします。</li>
		</ol>
		<p>ただし、当社の故意又は重過失による場合は、その限りではありません。</p>

		<h2 class="test-uppercase u-heading-v2__title g-mb-10">本サービスの保守</h2>
		<p>当社は、本サービスの稼働状態を良好に保つため、次の各号のいずれかに該当する場合、ご利用者に事前の通知を行うことなく、本サービスの一部、または全部を停止、および中止することができるものとします。</p>
		<ul>
			<li>システムの定期保守および緊急保守の場合</li>
			<li>火災、停電、第三者による妨害行為等により、システム運用が困難になった場合</li>
			<li>その他、止むを得ずシステム停止が必要と当社が判断した場合</li>
		</ul>

		<h2 class="test-uppercase u-heading-v2__title g-mb-10">広告</h2>
		<p>本サービス上のご利用者は、当社がその個人情報及びその個人固有の情報を利用して、電子メールその他の手段により本サービスに関する情報のご案内等の営業活動を行う事、ならびに当社が適切と判断した第三者の商品・サービス等の広告案内またはアンケート等の販売促進活動を行う事に予めご了承いただくものとします。</p>

		<h2 class="test-uppercase u-heading-v2__title g-mb-10">本利用規約の譲渡等</h2>
		<ol>
			<li>ご利用者は、当社の書面による事前の承諾なく、利用契約上の地位又は本規約に基づく権利若しくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。</li>
			<li>当社は本サービスにかかる事業を他社に譲渡した場合、当該事業譲渡に伴う利用契約上の地位、当規約に基づく権利及び義務、並びにご利用者様の登録情報、その他の顧客情報を当該事業譲渡の譲受人に譲渡することができるものとし、ご利用者様は、かかる譲渡について、本項において予め同意したものとします。<br>なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。</li>
		</ol>

		<h2 class="test-uppercase u-heading-v2__title g-mb-10">準拠法及び管轄裁判所</h2>
		<p>本利用規約の準拠法は日本法とし、本利用規約に起因、又は関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>
	</div>
        </div>

        <FooterVue></FooterVue>
    </div>
</template>

<script>
import HeaderVue from "../components/Header.vue";
import FooterVue from "../components/FFooter.vue";
export default {
    components: { HeaderVue, FooterVue },
    props: {},
    data() {
        return {};
    },
    mounted() { },
    methods: {},
};
</script>
<style scoped>
.banner {
    width: 77vw;
    margin: 0px auto;
    padding: 20px 0;
    box-sizing: border-box;
    color: #555;
}
</style>